import React, { forwardRef } from 'react';
import { get, isObject } from 'lodash';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import PRICING_MODEL from '../../../../config/pricingModel';
import BID_STRATEGIES from '../../../common-campaign-form/config/bidStrategies';
import FormattedNumberCellRenderer from './FormattedNumberCellRenderer';
import LabelLayoutCellRenderer from './LabelLayoutCellRenderer';

export const BidCellRenderer = props => {
    const {
        value,
        data: { pricingModel = PRICING_MODEL.CPC, bidStrategy },
    } = props;

    const isBidValueObject = isObject(value);
    const bidValue = isBidValueObject ? get(value, 'bid') : value;
    const shouldShowBidValue =
        !isBidValueObject || bidStrategy === BID_STRATEGIES.FIXED || bidStrategy === BID_STRATEGIES.SMART;

    return shouldShowBidValue && bidValue ? (
        <LabelLayoutCellRenderer
            className="bid-value"
            labelClassName="pricingModel"
            msgId={`app.campaigns.campaign.pricingModel.${pricingModel}`}
        >
            <FormattedNumberCellRenderer {...props} value={bidValue} />
        </LabelLayoutCellRenderer>
    ) : (
        <FormattedMessage id="app.campaigns.campaignsReports.bid.empty" defaultMessage="Auto" />
    );
};

export default forwardRef((props, _) => <BidCellRenderer {...props} />);
